var FailedOrdersService = /** @class */ (function () {
    function FailedOrdersService($http, $q) {
        'ngInject';
        this.$http = $http;
        this.$q = $q;
    }
    FailedOrdersService.prototype.getFailedOrderCart = function (failedOrderId, isAkrisOrder) {
        var _this = this;
        var url = isAkrisOrder ? 'api/cart/failedAkrisOrder/' : 'api/cart/failedOrder/';
        return this.$http.get(url + failedOrderId)
            .then(function (response) {
            if (response && response.status === 200 && response.data.response) {
                response.data.response['quantityOfCartItems'] = response.data.response.aresLineItems
                    .reduce(function (accum, item) {
                    return accum + item.quantity;
                }, 0);
                return response.data;
            }
            else {
                return _this.$q.reject(response);
            }
        })
            .catch(function (response) {
            return _this.$q.reject(response);
        });
    };
    FailedOrdersService.prototype.getFailedOrders = function () {
        var _this = this;
        return this.$http.get('api/account/orders/failedOrders')
            .then(function (response) {
            if (response && response.status === 200 && response.data.response) {
                return response.data.response;
            }
            else {
                return _this.$q.reject(response);
            }
        })
            .catch(function (response) {
            return _this.$q.reject(response);
        });
    };
    return FailedOrdersService;
}());
export { FailedOrdersService };
//# sourceMappingURL=failed-orders.service.js.map